import Vue from 'vue'
import Router from 'vue-router'
import home from '../pages/home';
import common from '../pages/common';
Vue.use(Router)

const originalPush = Router.prototype.push
Router.prototype.push = function push (location) {
  return originalPush.call(this, location).catch(err => err)
}
// router.afterEach((to,from,next)=>{
//   window,scrollTo(0,0)
// })

export default new Router({
  
  routes: [
    {
      path: '/',
      name: 'home',//首页
      component: home
    },
    {
      path: '/common/:id',
      name: 'common',//common
      component: common,
      children: [
        {
          path: 'huaianMuseumSummary',
          name: 'huaianMuseumSummary',
          component: () => import('../pages/modules/huaianMuseumSummary')
        },
        {
          path: 'manager',
          name: 'manager',
          component: () => import('../pages/modules/manager')
        },
        {
          path: 'member',
          name: 'member',
          component: () => import('../pages/modules/member')
        },
        {
          path: 'serviceGuide',
          name: 'serviceGuide',
          component: () => import('../pages/modules/serviceGuide')
        },
        {
          path: 'surveyByQuestionnaire',
          name: 'surveyByQuestionnaire',
          component: () => import('../pages/modules/surveyByQuestionnaire')
        },
        {
          path: 'volunteer',
          name: 'volunteer',
          component: () => import('../pages/modules/volunteer')
        },
        {
          path: 'exhibitionListOne',
          name: 'exhibitionListOne',
          component: () => import('../pages/modules/exhibitionListOne'),
        },
        {
          path: 'exhibitionListTwo',
          name: 'exhibitionListTwo',
          component: () => import('../pages/modules/exhibitionListTwo')
        },
        {
          path: 'exhibitionListDetail',
          name: 'exhibitionListDetail',
          component: () => import('../pages/modules/exhibitionListDetail')
        },
        {
          path: 'informationList',
          name: 'informationList',
          component: () => import('../pages/modules/informationList')
        },
        {
          path: 'informationDetail',
          name: 'informationDetail',
          component: () => import('../pages/modules/informationDetail')
        },
        {
          path: 'managerialSystem',
          name: 'managerialSystem',
          component: () => import('../pages/modules/managerialSystem')
        },
        {
          path: 'collectionList',
          name: 'collectionList',
          component: () => import('../pages/modules/collectionList')
        },
        {
          path: 'collectionDetail',
          name: 'collectionDetail',
          component: () => import('../pages/modules/collectionDetail')
        },
        {
          path: 'bigNote',
          name: 'bigNote',
          component: () => import('../pages/modules/bigNote')
        },
        {
          path: 'entrance',
          name: 'entrance',
          component: () => import('../pages/modules/entrance')
        },
        {
          path: 'educationList',
          name: 'educationList',
          component: () => import('../pages/modules/educationList')
        },
        {
          path: 'culturalCreationList',
          name: 'culturalCreationList',
          component: () => import('../pages/modules/culturalCreationList')
        },
        {
          path: 'cultralProductionDetail',
          name: 'cultralProductionDetail',
          component: () => import('../pages/modules/cultralProductionDetail')
        },
        {
          path: 'reSearchList',
          name: 'reSearchList',
          component: () => import('../pages/modules/reSearchList')
        },
        {
          path: 'researchListDetail',
          name: 'researchListDetail',
          component: () => import('../pages/modules/researchListDetail')
        },
        {
          path: 'informationTip',
          name: 'informationTip',
          component: () => import('../pages/modules/informationTip')
        },
        {
          path: 'error',
          name: 'error',
          component: () => import('../pages/modules/error')
        },
        {
          path: 'empty',
          name: 'empty',
          component: () => import('../pages/modules/empty')
        },
      ]
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js